import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getMyInformation } from "./api/signin";

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [dataMyInfo, setDataMyInfo] = useState(null);

  const fetchMyInfo = useCallback(() => {
    if (
      localStorage.getItem("my_information") === null &&
      localStorage.getItem("emr_token") !== null &&
      localStorage.getItem("emr_token") !== undefined &&
      localStorage.getItem("emr_token").length > 0
    ) {
      getMyInformation()
        .then((x) => {
          localStorage.setItem("my_information", JSON.stringify(x));
          setDataMyInfo(x);
        })
        .catch((z) => console.log(z));
    } else if (
      localStorage.getItem("my_information") &&
      localStorage.getItem("my_information") !== null
    ) {
      setDataMyInfo(JSON.parse(localStorage.getItem("my_information")));
    }
  }, [localStorage]);

  useEffect(() => {
    fetchMyInfo();
  }, []);

  return <MyContext.Provider value={dataMyInfo}>{children}</MyContext.Provider>;
};

export const useMyContext = () => {
  const context = useContext(MyContext);
  if (context === undefined) {
    throw new Error("useMyContext must be used within a MyProvider");
  }
  return context;
};
